var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2519 30",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    className: "hrSVG",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    @keyframes drawLine {\r\n      to {\r\n        stroke-dashoffset: 0;\r\n      }\r\n    }\r\n    path {\r\n      stroke-dasharray: 2508.47;\r\n      stroke-dashoffset: 2508.47;\r\n      animation: drawLine 3s ease forwards;\r\n    }\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-23.9807,-84.3202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.292,107.219C58.362,115.524 1047.31,84.963 1308.84,105.081C1360.58,109.061 2387.73,74.621 2537.08,97.598",
    fill: "none",
    stroke: "black",
    strokeWidth: 7,
    strokeDasharray: 2508.47,
    strokeDashoffset: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.b7d2fe6bfc1c9c14f41f17af347876f4.svg";
export { ForwardRef as ReactComponent };